import { useMutation } from "@tanstack/react-query";
import api from "apis";
import { DocumentAttachmentFileSaveRequest } from "apis/data-contracts";

export interface SaveAdditionalAttachmentFilesParams {
  uuid: string;
  data: DocumentAttachmentFileSaveRequest;
}

export const useSaveAdditionalAttachmentFiles = () => {
  return useMutation({
    mutationFn: ({ uuid, data }: SaveAdditionalAttachmentFilesParams) =>
      api.document.saveAdditionalAttachmentFiles(uuid, data),
  });
};
